import { useState, useEffect } from 'react';
// import { ASSETS_BASE_URL } from '../config/config';

export default function useLogo(loading, event) {
  const [logoPadding, setLogoPadding] = useState('12px');
  const [logoBackground, setLogoBackground] = useState('#ffffff');
  const [logoPath, setLogoPath] = useState();
  const [logoArr, setLogoArr] = useState([]);

  useEffect(() => {
    if (loading || event.length === 0) return;

    console.log('eventFromuseLogo', event?.webcast?.branding?.logoSelection)

    if(event?.webcast?.branding?.logoSelection) {
      setLogoPath(event?.webcast?.branding?.logoSelection?.path?.startsWith('http') ? event?.webcast?.branding?.logoSelection?.path : `${process.env.REACT_APP_ASSETS_BASE_URL}/${event?.webcast?.branding?.logoSelection?.path}`);
      return;
    } else {
           event?.companies[0].logos.forEach((item) => {
        if (item.type === 'website') {
          // console.log('LOGOS', item);
          setLogoArr((logoArr) => [...logoArr, item]);
          // return setLogoPath(`${process.env.REACT_APP_ASSETS_BASE_URL}/${item.upload.path}`);
        } 
      });
    }

    // if (event?.companies[0]) {
    //   event?.companies[0].logos.forEach((item) => {
    //     if (item.type === 'website') {
    //       // console.log('LOGOS', item);
    //       setLogoArr((logoArr) => [...logoArr, item]);
    //       // return setLogoPath(`${process.env.REACT_APP_ASSETS_BASE_URL}/${item.upload.path}`);
    //     } 
    //   });
    // }

    if (event?.webcast?.branding) {
      if (event?.webcast?.branding?.logo) {
        if (event?.webcast?.branding?.logo?.padding !== '') {
          const logo = event?.webcast?.branding?.logo;
          setLogoPadding(logo.padding);
        }
      }
    }

    if (event?.webcast) {
      if (event?.webcast?.colour) {
        if (event?.webcast?.colour?.background) {
          setLogoBackground(event?.webcast?.colour?.background);
        }
      }
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (logoArr.length > 0) {
      setLogoPath(`${process.env.REACT_APP_ASSETS_BASE_URL}/${logoArr[0].upload.path}`);
    }
  }, [logoArr]);

  return [logoPath, logoPadding, logoBackground];
}
